<template>
	<div>
       <b-overlay :show="psLoading" opacity="0.2">
            <b-card class="mt-1" body-class="p-75">
                <h2 class="p-25 font-weight-bolder">Haftalık İşlem Hareketleri</h2>
                <vue-perfect-scrollbar class="card-wrapper">
                    <table class="table table-bordered table-sm mb-1 ">
                        <thead>
                            <tr>
                                <th class="text-nowrap w-10">Ref. Kodu</th>
                                <th class="text-nowrap w-10">Cari Kod</th>
                                <th class="text-nowrap w-10">Cari Adı</th>
                                <th class="text-nowrap w-10">Sor. Kul.</th>
                                <th class="text-nowrap w-10">Sor. Kul. Son Yanıt Tarihi</th>
                                <th class="text-nowrap w-10">Sor. Kul. Yanıt Tarihi</th>
                                <th class="text-nowrap w-20">Açıklama</th>
                                <th class="text-nowrap w-10">Tutar (TL)</th>
                                <th class="text-nowrap w-7">Gönderilme Tarihi</th>
                                <th class="text-nowrap w-8">Son Ödeme Tarihi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="ps in paymentStatuses" >
                                <tr :key="ps.Id">
                                    <td class="text-nowrap">
                                        <a :href="'/Payment/'+ps.InvoiceGroupCode" target="_blank">{{$safe(ps,'InvoiceGroupCode') || '-'}}</a>
                                    </td>
                                    <td class="text-nowrap">{{$safe(ps,'CariCode') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'CariName') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'ResponsibleUserName') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'ResponsibleUserLastApproveDate') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'ResponsibleUserApproveDate') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'Description') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'TotalAmount') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'CreateTime') || '-'}}</td>
                                    <td class="text-nowrap">{{$safe(ps,'InvoiceLastPaymentDate') || '-'}}</td>
                                </tr>
                                <tr  :key="ps.Id + '-dl'" v-if="ps.DocumentList">
                                    <td colspan="20">
                                        <div class="table-responsive mb-0">
                                            <table class="table table-bordered table-sm">
                                                <thead>
                                                    <th class="text-nowrap w-5">Fatura Numarası</th>
                                                    <th class="text-nowrap w-8">Fatura Kesim Tarihi</th>
                                                    <th class="text-nowrap w-5">Faturasız Ödeme Mi?</th>
                                                    <th class="text-nowrap w-15">Borç</th>
                                                    <th class="text-nowrap w-15">Ödenen Tutar</th>
                                                    <th class="text-nowrap w-15">Kalan Borç</th>
                                                    <th class="text-nowrap w-30">Durum</th>
                                                    <th class="text-nowrap w-7">Ödeme Zamanı</th>

                                                </thead>
                                                <tbody>
                                                    <tr :class="setPaymentStatusColor(dl.Status)" v-for="dl in ps.DocumentList" :key="dl.DocumentNo">
                                                        <td>{{$safe(dl,'DocumentNo') || '-'}}</td>
                                                        <td>{{$safe(dl,'Date') || '-'}}</td>
                                                        <td>
                                                            <template>
                                                                <div class="text-center">
                                                                    <span v-if="dl.IsWithoutInvoice === true" class="material-icons-outlined text-success">check_circle</span>
                                                                    <span v-else class="material-icons-outlined text-danger">cancel</span>
                                                                </div>
                                                            </template>
                                                            
                                                        </td>
                                                        <td>{{$safe(dl,'Debt') || '-'}}</td>
                                                        <td>{{$safe(dl,'PaidPart') || '-'}}</td>
                                                        <td>{{$safe(dl,'RemainingDebt') || '-'}}</td>
                                                        <td>{{$safe(dl,'StatusStr') || '-'}}</td>
                                                        <td>{{$safe(dl,'InvoicePaymentDate') || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="paymentStatuses.length == 0">
                                <td colspan="20" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                            </tr>
                        </tbody>
                    </table>
                </vue-perfect-scrollbar>
            </b-card>
        </b-overlay>

	</div>
</template>

<script>
import { BCard, BCardText, BLink,BImg,BOverlay,BSpinner } from 'bootstrap-vue'
//import Notifications from '@/utilities/notifications'
import {PaymentApi} from '@/api/payment'
import VStatsBox from '@/components/VStatsBox.vue'
import Auth from '@/utilities/auth'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BImg,
        VStatsBox,
        VuePerfectScrollbar,
        BOverlay,
        BSpinner
    },
    data() {
        return {
            date:null,
            month:null,
            paymentStatuses:[],
            responsibleUserPaymentStatuses:[],
            psLoading:false,
            rupsLoading:false,
            approving:false,
            cid:null,
            pending:false
        }
    },
    mounted(){
        this.getLastWeekPaymentStatuses()
    },
    methods:{
        setPaymentStatusColor(paymentStatus){
            if(paymentStatus == 6 || paymentStatus == 7)
                return 'bg-light-success'
            if(paymentStatus == 5)
                return 'bg-light-primary'
            if(paymentStatus == 4 || paymentStatus == 2)
                return 'bg-light-danger'
            if(paymentStatus == 0)
                return 'bg-light-info'
                if(paymentStatus == 3)
                return 'bg-light-warning'
            return ''
        },
        getLastWeekPaymentStatuses(){
            this.psLoading = true
            PaymentApi.SalesmanLastWeekPaymentStatusList().then(res=>{
                this.psLoading = false
                this.paymentStatuses = res.data.Data
            }).catch(()=>this.psLoading = false)
        },
        
    }
}
</script>

<style>
.card-wrapper{
    max-height:calc(100vh - 22rem);
}

@media screen and (max-width:767px) {
    .card-wrapper{
        max-height:calc(100vh - 30rem);
    }
}
</style>
